/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/filosofia.jpg";
import bgBack from "assets/images/mision.jpg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="print"
                title={
                  <>
                    Nuestra
                    <br />
                    Filosofía
                  </>
                }
                description="Comprometidos con la calidad, la innovación y el servicio al cliente."
              />
              <RotatingCardBack
                image={bgBack}
                title="Misión"
                description="Proveer productos y servicios de alta calidad con atención personalizada y soluciones confiables para todas sus necesidades de impresión y papelería."
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/about-us",
                  label: "conoce más",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="inventory_2"
                  title="Amplio Catálogo"
                  description="Desde hojas bond y papeles especiales hasta tintas y cartuchos para todo tipo de impresión."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="local_shipping"
                  title="Logística Propia"
                  description="Sistema de distribución eficiente para garantizar entregas puntuales en toda la región."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="print"
                  title="Servicios de Impresión"
                  description="Impresión digital, offset y gran formato con la mejor tecnología del mercado."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="verified"
                  title="Calidad Garantizada"
                  description="Nuestros valores de honestidad, confianza y responsabilidad social nos respaldan."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
